import type { IIconZaiAnimationProps } from './types'

export const ICON_ZAI_INITIAL_PROPS: IIconZaiAnimationProps = {
  color: 'var(--color_neutral_0)',
  size: { width: 24, height: 24 },
}
